<div class="grid" data-test-id="aufgabe-anschreiben-root">
	@if (multipleVorlagen()) {
		@for (control of bodyControls.vorlageIds.controls; track $index) {
			<div class="row" data-test-id="vorlage">
				<mat-form-field appearance="outline">
					<mat-label>Vorlage</mat-label>
					<mat-select cdkFocusInitial [formControl]="control" data-test-id="one-value-select-input">
						@for (vorlage of vorlagen(); track vorlage) {
							<mat-option
								[value]="getVorlageId(vorlage)"
								class="focus-inwards-dark"
								data-test-id="one-value-select-value">
								{{ vorlage.name }}
							</mat-option>
						}
					</mat-select>
					<mat-error>Vorlage {{ KorrespondenzValidationMessages.MISSING_REQUIRED_SELECT_VALUE }}</mat-error>
				</mat-form-field>
				@if ($count > 1) {
					<schir-int-client-button-round
						toolTip="Vorlage entfernen"
						materialIcon="remove"
						(click)="removeVorlageSelect($index)"
						cssClass="focus-inwards-dark schir-midi-button" />
				}
				@if ($last) {
					<schir-int-client-button-round
						toolTip="Weitere Vorlage hinzufügen"
						materialIcon="add"
						(click)="addVorlageSelect()"
						cssClass="focus-inwards-dark schir-midi-button"
						data-test-id="add-vorlage" />
				}
			</div>
		}
	} @else {
		<div class="row">
			<mat-form-field appearance="outline">
				<mat-label>
					Vorlage
					{{
						bodyControls.vorlageId.value === VorlageService.BENUTZERDEFINIERTE_VORLAGE_ID
							? ' (benutzerdefiniert)'
							: ''
					}}
				</mat-label>
				<mat-select
					cdkFocusInitial
					[formControl]="bodyControls.vorlageId"
					data-test-id="one-value-select-input">
					@for (vorlage of vorlagen(); track vorlage) {
						<mat-option
							[value]="getVorlageId(vorlage)"
							class="focus-inwards-dark"
							data-test-id="one-value-select-value">
							{{ vorlage.name }}
						</mat-option>
					}
				</mat-select>
				<mat-error>Vorlage {{ KorrespondenzValidationMessages.MISSING_REQUIRED_SELECT_VALUE }}</mat-error>
			</mat-form-field>
		</div>
	}

	<div class="row">
		<schir-int-client-one-value-editor type="date" label="Datum" [fieldControl]="bodyControls.datum" />
	</div>

	<div class="row">
		<schir-int-client-one-value-editor
			type="text"
			label="Rechtspfleger"
			[fieldControl]="bodyControls.rechtspfleger" />
	</div>

	<div class="row">
		<div class="column taetigkeit">
			<mat-radio-group aria-label="Bitte Aktion wählen" class="column" [formControl]="bodyControls.taetigkeit">
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="AufgabeVersandTaetigkeit.SENDEN_AN"
					data-test-id="senden-an-radio-button">
					senden an
				</mat-radio-button>
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="AufgabeVersandTaetigkeit.AUSHAENDIGEN_AN"
					data-test-id="aushaendigen-an-radio-button">
					aushändigen an
				</mat-radio-button>
			</mat-radio-group>
		</div>
		<schir-int-client-kontakt-kategorie-checkboxes
			class="column"
			[control]="bodyControls.empfaenger"
			[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer()"
			data-test-id="kontakt-kategorie-checkbox-root" />
	</div>

	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.ANSCHREIBEN" />
</div>
